/** Date serialized as string */
export type DateString =
  `${number}-${number}-${number}}T${number}:${number}:${number}Z` &
    (string & {});

export type DateConvertable = number | string | Date;
/**
 * @param date {DateConvertable} any valid `Date` constructor parameter
 * @returns {string} YYYY-MM-DD formatted date string
 */
export function serializeDate(date: DateConvertable): string {
  return new Date(date).toISOString().split("T")[0]; // Format as YYYY-MM-DD
}

export type DateRangeFilter = {
  from_date: DateConvertable;
  to_date?: DateConvertable;
};
export function todayFilter(): DateRangeFilter {
  return { from_date: serializeDate(new Date()) };
}

export const lifetimeDate = new Date("2125-01-01").getTime();
